import React,{useState,useEffect} from "react";
import { Link } from "react-router-dom";
import {getAllData , deleteIdData} from "../../../lib/booklist"

export default  function AdminBookList() {
 
const [booklist, setBookList] = useState([])


const handleDelete =  async(id) => {
  const choice = window.confirm(
    'Are You Sure?'
  );
  if (choice) {
    await deleteIdData(id);
    GetData();
    //console.log("Delete",id);
    //router.refresh();
  }
 
};

  async function GetData() {
    const books = await getAllData();
    setBookList(books);
    console.log("books",books);
  }

useEffect(() => {
  GetData();
}, [])

  const essentialheader = (name, buttonname, buttonlink) => {
        return (
          <div className="d-flex p-2 justify-content-between align-items-center">
            <div className="d-flex p-2">
              <h3>{name}</h3>
              <p></p>
            </div>
            <div className="d-flex">
              <div className="ticket-btn-grp">
                    <Link
                      to={buttonlink}
                    >
                      {buttonname}
                    </Link>
                </div>
              </div>
          </div>
      );
    }

  return (
            <div className="col-xl-12 col-md-12">
              <div className="settings-widget profile-details">
                <div className="settings-inner-blk p-0">
                  {essentialheader(
                    "Book List",
                    "Create New Book",
                    "/admin/admin-booklist-edit/Add"
                  )}
                  <div className="comman-space pb-0">
                    <div className="settings-invoice-blk table-responsive">
                      {/* Invoice info */}
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <th>Id</th>
                            <th>Title</th>
                            <th>Author</th>
                            <th>Is Active</th>
                            <th>&nbsp;</th>
                          </tr>
                        </thead>
                        <tbody>
                        {booklist.map(function (data) {
                          return (
                            <tr key={data.id}>
                            <td>
                              <Link
                                to="#"
                                className="invoice-no"
                              >
                              {data.id}
                              </Link>
                            </td>
                            <td>{data.title}</td>
                            <td>{data.author}</td>
                            <td>{data.isActive ? <span className="badge info-low">True</span> : <span className="badge info-high">False</span>}</td>
                            <td>
                            <div className="profile-share d-flex align-items-center justify-content-end">
                                <Link to= {`/admin/admin-booklist-edit/${data.id}`} className="btn btn-success btn-sm">
                                  Update
                                </Link>
                                <button className="btn btn-danger btn-sm" onClick={() => handleDelete(data.id)}>
                                Delete
                                </button>
                          </div>
                            </td>
                          </tr>
                          )
                        })}
                        </tbody>
                      </table>
                      {/* Invoice info */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
  );
}
